
import { Payload } from "@/types/profile";

export const mediaPayloads: Payload[] = [
  // AirPlay payloads
  {
    id: "airplay",
    name: "AirPlay",
    description: "Configure AirPlay settings",
    category: "Media",
    supportedPlatforms: ["macos", "ios", "ipados", "tvos"],
    configFields: [
      {
        id: "forcedAirPlayDestinations",
        name: "Forced AirPlay Destinations",
        type: "textarea",
        required: false,
        description: "List of AirPlay destinations to enforce (one per line)"
      },
      {
        id: "airPlaySecurityType",
        name: "AirPlay Security Type",
        type: "select",
        required: false,
        options: ["None", "Password", "Passcode"],
        default: "None",
        description: "Security type for AirPlay"
      }
    ]
  },
  
  // Font payloads
  {
    id: "font",
    name: "Font",
    description: "Install fonts on devices",
    category: "Media",
    supportedPlatforms: ["macos", "ios", "ipados"],
    configFields: [
      {
        id: "fontFile",
        name: "Font File",
        type: "file",
        required: true,
        description: "Font file to install (.ttf, .otf)"
      },
      {
        id: "fontName",
        name: "Font Name",
        type: "text",
        required: false,
        description: "Name of the font"
      }
    ]
  },
  
  // Media Management payloads
  {
    id: "media-management",
    name: "Media Management",
    description: "Configure media management settings",
    category: "Media",
    supportedPlatforms: ["macos"],
    configFields: [
      {
        id: "allowMediaSharing",
        name: "Allow Media Sharing",
        type: "boolean",
        required: false,
        default: true,
        description: "Allow sharing of media with other devices"
      }
    ]
  },
  
  // Wallpaper payloads
  {
    id: "wallpaper",
    name: "Wallpaper",
    description: "Set wallpaper for devices",
    category: "Media",
    supportedPlatforms: ["ios", "ipados", "tvos"],
    configFields: [
      {
        id: "image",
        name: "Wallpaper Image",
        type: "file",
        required: true,
        description: "Image to use as wallpaper"
      },
      {
        id: "where",
        name: "Apply To",
        type: "select",
        required: true,
        options: ["Lock Screen", "Home Screen", "Both"],
        default: "Both",
        description: "Where to apply the wallpaper"
      }
    ]
  }
];
